import { render, staticRenderFns } from "./DialogFiles.vue?vue&type=template&id=625ec73c&scoped=true"
import script from "./DialogFiles.vue?vue&type=script&lang=js"
export * from "./DialogFiles.vue?vue&type=script&lang=js"
import style0 from "./DialogFiles.vue?vue&type=style&index=0&id=625ec73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625ec73c",
  null
  
)

export default component.exports